import GrpcRioClient from './grpc';
import initClient from './grpc/initClient';
export { initClient };
export default GrpcRioClient;